module.exports = __webpack_public_path__ + "fonts/Roboto-300-vietnamese28.3860f0d.woff2";